import { axios, Response } from '..'

export type Body = {
  title: string
  hexadecimalColorCode: string
}

export interface CreateTaskTagResponse {
  id: number
  title: string
  hexadecimalColorCode: string
}

export const createTaskTag = (
  taskId: string,
  createTaskTagRequest: Body
): Response<CreateTaskTagResponse> => {
  return axios.post(`/v1/tasks/${taskId}/tags`, createTaskTagRequest)
}
